import React from 'react';
import ReportTemplateSettings from '../../views/ReportTemplateSettings';

const ReportSettingsTab: React.FC = () => (
  <ReportTemplateSettings embedded />
);

export default ReportSettingsTab;
